/*
 * @Description:
 */

export default {
  common: {
    setSuccess: '设置成功',
    cancelSuccess: '取消成功',
    selectDateTip: '请选择日期',
    notes: '备注',
    append: '新增',
    indexNumber: '序号',
    deleteStatus: '删除状态',
    serialNumber: '编号',
    qty: '数量',
    search: '检索',
    reset: '重置',
    submit: '提交',
    delete: '删除',
    edit: '编辑',
    examine: '查看',
    operate: '操作',
    operateSuccess: '操作成功！',
    updateSuccess: '更新成功！',
    createSuccess: '创建成功！',
    deleteTip: '此操作将删除此条记录, 是否继续?',
    deleteSuccess: '删除成功！',
    cancelDelete: '已取消删除！',
    create: '创建',
    isActive: '是否可用',
    active: '可用',
    notActive: '不可用',
    isRequired: '是必需的',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    minNumber: '最小值为: ',
    add: '添加',
    end: '结束',
    next: '下一步',
    value: '值',
    finish: '完成',
    inputSearch: '请输入搜索信息并Enter!',
    baseInfo: '基本信息',
    needQuantity: '所需数量',
    save: '保存',
    all: '全部',
    yes: '是',
    no: '否',
    downloadTip: '点击文件名下载',
    noData: '暂无数据',
    none: '无',
    cancel: '取消',
    time: '时间',
    completed: '已完成',
    canceled: '已取消',
    rejected: '已驳回',
    reject: '驳回',
    max100WordsTip: '最多不超过100个字',
    select: '选择',
    isProcess: '是否提交审批',
    back: '返回',
    onCapsLock: '大写锁定键已开启',
    setDefault: '设为默认',
    batchImport: '批量导入',
    hasApproved: '已通过',
    partiallyPassed: '部分通过',
    downloadTemplate: '下载模板',
    inputFormatP: '输入格式错误',
    greaterThanZeroP: '输入的值需大于0',
    loading: '加载中...',
    copySuccess: '复制成功',
    copyError: '复制失败',
    exportExcel: 'Excel导出'
  },
  route: {
    dashboard: '首页',
    userInfo: '个人信息',
    resetPassword: '密码修改',
    mfaBind: 'MFA绑定',
    mainDataManagement: '主数据管理',
    company: '公司',
    companyDetails: '公司主数据详情',
    companyCreate: '添加公司主数据',
    companyUpdate: '修改公司主数据',
    supplier: '供应商',
    supplierCreate: '添加供应商主数据',
    supplierUpdate: '修改供应商主数据',
    employee: '员工',
    employeeCreate: '添加员工主数据',
    employeeUpdate: '修改员工主数据',
    applicationFormManagement: '申请单管理',
    paymentRequestSAP: '付款申请(SAP)',
    specialPaymentRequestPO: '特殊付款申请(PO)',
    createSpecialPaymentRequestPO: '新建特殊付款申请(PO)',
    updateSpecialPaymentRequestPO: '修改特殊付款申请(PO)',
    specialPaymentRequestNoPO: '特殊付款申请(无PO)',
    createSpecialPaymentRequestNoPO: '新建特殊付款申请(无PO)',
    updateSpecialPaymentRequestNoPO: '修改特殊付款申请(无PO)',
    reimbursementRequest: '报销申请',
    createSpecialPaymentRequestReimb: '新建报销申请',
    updateSpecialPaymentRequestReimb: '修改报销申请',
    paymentRequestRefund: '客户退款申请',
    createPaymentRequestRefund: '新建客户退款申请',
    updatePaymentRequestRefund: '修改客户退款申请',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    system: '系统管理',
    member: '用户管理',
    role: '角色管理',
    permission: '权限管理',
    approvalFormManagement: '审批单管理',
    approvalForm: '审批单处理',
    returnApprovalForm: '返回审批列表',
    approvalFormDetail: '审批单详情',
    approvalFormHistory: '历史审批单',
    approvalFormHistoryDetail: '历史审批单详情',
    process: '审批流管理',
    processEdit: '编辑审批流信息',
    paymentSlipManagement: '支付管理',
    PlannedPaymentSlip: '计划支付单',
    plannedPaymentSlipReports: '计划支付单报表',
    outsidePaymentSlip: '外汇或体外支付单',
    pendingExecutionPaymentSlip: '待执行支付单',
    paymentSlipBufferDetailDetail: '待执行支付单详情',
    paymentSlipDetails: '支付单详情',
    paymentSlipHistory: '历史支付单',
    paymentSlipHistoryCashDetail: '历史支付单详情',
    paymentSlipHistoryAcceptanceDetail: '支付单详情',
    plannedPaymentSlipDetail: '计划支付单-支付详情',
    acceptanceManagement: '承兑票管理',
    acceptanceReceive: '承兑票接收',
    acceptanceReceiptDetail: '承兑票详情',
    acceptanceApproval: '承兑票审批',
    acceptanceApprovalDetail: '审批详情',
    acceptanceApprovalHistory: '承兑票审批历史',
    acceptanceApprovalHistoryDetail: '审批详情',
    acceptanceHistory: '历史承兑票',
    acceptanceHistoryDetail: '承兑票详情',
    paymentStatement: '交易流水',
    downloadHistoryReceipt: '下载历史回单',
    acceptanceBillsList: '承兑票清单',
    acceptanceBillsDetail: '承兑票清单详情'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    theme: '换肤',
    size: '布局大小',
    profile: '个人中心',
    userInfo: '个人信息',
    resetPassword: '密码修改',
    setMFA: 'MFA绑定'
  },
  login: {
    title: 'CEFWARE',
    logIn: '登录',
    username: '账号',
    password: '密码'
  },
  permission: {
    name: '权限名称',
    createRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    createSuccessMessage: '创建成功',
    editSuccessMessage: '更新成功',
    deleteTipMessage: '此操作将删除权限, 是否继续?',
    cancelDeleteMessage: '已取消权限删除',
    delete: 'Delete',
    edit: '编辑权限',
    confirm: 'Confirm',
    cancel: 'Cancel',
    create: '新增权限',
    permissionUrl: '权限路径',
    permissionAuth: '权限编码',
    permissionLv: '权限层级',
    parentPermissionName: '父权限名'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  user: {
    name: '用户名',
    account: '访问id',
    roleNames: '用户角色',
    password: '密码',
    passwordConfirm: '密码确认',
    create: '用户创建',
    edit: '用户编辑',
    updatePassword: '修改用户密码',
    createSuccessMessage: '创建成功',
    editSuccessMessage: '更新成功',
    deleteTipMessage: '此操作将删除用户, 是否继续?',
    cancelDeleteMessage: '已取消用户删除',
    deleteMessage: '删除成功',
    mailAddress: '邮箱',
    department: '部门',
    isActive: '是否活跃',
    changePasswordInitializeMessage: '初始化密码',
    confirmChangePasswordMessage: '确认初始化密码？',
    passwordInitializedMessage: '密码已初始化并发送给用户',
    cancelPasswordInitializedMessage: '已取消初始化密码',
    loginUser: '登录名'
  },
  role: {
    name: '角色名',
    edit: '编辑角色',
    create: '创建角色',
    editAuthorization: '编辑角色权限',
    permissions: '角色权限',
    allPermissions: '全部权限',
    createSuccessMessage: '创建成功',
    editSuccessMessage: '更新成功',
    deleteTipMessage: '此操作将删除角色, 是否继续?',
    cancelDeleteMessage: '已取消删除角色',
    deleteMessage: '删除成功',
    noRoleId: '没有角色id',
    updateAuthorizationSuccessMessage: '编辑角色权限成功'
  },
  dommonData: {
    name: '名称',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    isActive: '是否活跃',
    active: '活跃',
    notActive: '非活跃'
  },
  message: {
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    yes: '是',
    no: '否'
  },
  form: {
    selectPlaceholder: '请选择',
    isRequired: '是必需的',
    passwordNotMatch: '两次输入密码不一致'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  errorMsg: {
    notFound: '没有找到',
    checkError: '校验失败',
    checkEmptyError: '不能为空',
    checkExistError: '已存在',
    canNotDelete: '无法删除',
    dataNotMatch: '数据不匹配',
    internalError: '内部错误'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    showTagsView: '显示 Tags-View',
    showSidebarLogo: '显示侧边栏 Logo',
    fixedHeader: '固定 Header',
    sidebarTextTheme: '侧边栏文字主题色'
  },
  userInfo: {
    userAccount: '登录名',
    userName: '用户名',
    mailAddress: '邮箱地址',
    userRoleNames: '角色',
    department: '部门'
  },
  restPassword: {
    originalPassword: '原密码',
    oriPasswordP: '原密码不能为空',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    lengthP: '密码长度需大于10位!',
    ruleP: '必须包含字母，特殊符号，数字，大小写其中三种!',
    repeatAccountP: '密码不得与用户名重复!',
    differentP: '与输入的新密码不一致!'
  },
  mfa: {
    mfaBind: 'MFA绑定',
    mfaStatus: 'MFA状态',
    unbound: '未绑定',
    bonded: '已绑定',
    bindNow: '立刻绑定',
    rebind: '重新绑定',
    password: '登录密码',
    passwordP: '登录密码不能为空',
    mfaBindTip: '请在手机上安装Authenticator程序，扫码绑定后，在下方输入校验码。',
    mfaChecksum: 'MFA校验码',
    mfaChecksumP: 'MFA校验码不能为空',
    bind: '绑定'
  },
  bank: {
    bankInfo: '银行信息',
    selectBankInfoP: '请选择银行信息',
    bankInfoP: '银行信息不能为空',
    bankAccount: '银行账号',
    bankAccountP: '银行账号不能为空',
    bankCode: '银行编号',
    bankCodeP: '银行编号不能为空',
    bankNumber: '行号',
    bankNumberP: '行号不能为空',
    bankName: '银行名称',
    bankNameP: '银行名称不能为空',
    paymentTerms: '付款周期(天)',
    paymentTermsP: '付款周期不能为空',
    isForeignExchange: '是否外汇',
    isForeignExchangeOrExternal: '是否外汇 (或体外支付)',
    isForeignExchangeOrExternalP: '是否外汇 (或体外支付) 不能为空',
    isPriorityAcceptanceBill: '承兑优先使用',
    isPriorityAcceptanceBillP: '承兑优先使用不能为空',
    amount: '金额',
    amountP: '金额不能为空',
    totalAmount: '合计金额',
    currency: '币种',
    currencyP: '币种不能为空',
    bankCity: '银行所在城市',
    bankCityP: '银行所在城市不能为空',
    amountApproved: '已通过金额'
  },
  company: {
    companyMaster: '公司主数据',
    companyName: '公司名',
    companyNameP: '公司名不能为空',
    companyCode: '公司编码',
    companyCodeP: '公司编码不能为空'
  },
  employee: {
    employeeP: '员工数据不能为空',
    employeeMaster: '员工主数据',
    nameCn: '中文姓名',
    nameCnP: '中文姓名不能为空',
    nameEn: '英文姓名',
    nameEnP: '英文姓名不能为空',
    employeeId: '工号',
    employeeIdP: '工号不能为空',
    employingCompany: '所属公司',
    employingCompanyP: '所属公司不能为空',
    email: '邮箱',
    emailIsNull: '邮箱不能为空',
    emailIsError: '邮箱格式不正确',
    employeeNumber: '员工编号',
    employeeName: '员工姓名'
  },
  supplier: {
    supplierMaster: '供应商主数据',
    supplierCode: '供应商编码',
    supplierName: '供应商名称',
    supplierNameP: '供应商名称不能为空',
    supplierCodeP: '供应商编码不能为空',
    selectSupplierP: '请选择供应商',
    customerName: '客户名称',
    customerNameP: '客户名称不能为空'
  },
  order: {
    orderOperations: '订单操作',
    orderFunctions: '订单功能',
    selectTip: '请选择需要设置的订单',
    setPaymentDate: '设置付款日',
    setPaymentDateP: '付款日期不能为空',
    selectedApplicationForm: '已选申请单',
    cancelApplication: '取消申请',
    batchUpload: '批量上传',
    generateApprovalForm: '生成审批单',
    documentNumber: '凭证号 (Document Number)',
    invoiceNumber: '发票号',
    cutOffDate: '到期日',
    paymentDate: '付款日',
    paymentDateP: '付款日不能为空',
    purposePayeeMayView: '用途(收款方可查看)',
    purposePayeeMayViewNullP: '用途(收款方可查看)不能为空',
    purposePayeeMayViewP: '请输入用途(收款方可查看)',
    isCompanyAccount: '是否对公',
    isCompanyAccountP: '是否对公不能为空',
    paymentDocuments: '付款支持文件'
  },
  approvalForm: {
    approvalFormList: '待处理审批单',
    deadline: '截止时间',
    currentApprover: '当前审批人',
    submitDate: '提交时间',
    submitter: '提交人',
    id: '序号',
    toBeSubmitted: '待提交',
    pendingLevel1Approval: '待一级审批',
    pendingLevel2Approval: '待二级审批',
    pendingLevel3Approval: '待三级审批',
    approvalFormDetail: '审批详情',
    documentNumber: '凭证号(Document Number)',
    reference: '发票号',
    amount: '金额',
    currency: '币种',
    dueDate: '截止日',
    text: '备注',
    paymentDate: '付款日',
    purpose: '用途',
    purposeP: '用途不能为空',
    specialPaymentType: '付款类型',
    specialPaymentTypeP: '付款类型不能为空',
    comment: '备注',
    approvalFormHistoryList: '历史审批单',
    operateDate: '操作时间',
    cancelSelect: '移除所选项',
    cancelAll: '全部取消',
    submit: '提交审核',
    rejectSelect: '驳回所选项',
    rejectAll: '全部驳回',
    approved: '审批通过',
    rejected: '审批驳回',
    cancelTip: '注意：被取消的申请单将被从页面中移除，需从新上传申请后才能再次提交。',
    cancelConfirmTip: '确认取消？',
    rejectTip: '注意：被驳回的申请单需重新上传申请后才能再次提交。',
    rejectSelected: '已选驳回项',
    rejectComment: '驳回原因',
    finalApprover: '最终审批人',
    approver: '审批人',
    approvalResult: '审批结果',
    approvalProcess: '审批流程'
  },
  process: {
    processList: '审批流管理',
    processName: '审批流名称',
    isActive: '是否激活',
    yes: '是',
    no: '否',
    id: '序号',
    companyName: '公司名称',
    active: '是否活跃',
    processEdit: '编辑审批流信息',
    processLine: '审批路线',
    level1Approver: '一级审批',
    level2Approver: '二级审批',
    level3Approver: '三级审批',
    addApprover: '添加审批人',
    deleteApprover: '去除',
    save: '保存',
    hasApprover: '审批人已存在',
    ApproverEmpty: '审批人列表不能为空'
  },
  pay: {
    payList: '计划支付单',
    payListIsEmpty: '计划支付单为空',
    payee: '收款方',
    dueDate: '截止日',
    currency: '币种',
    id: '序号',
    reference: '发票号',
    amount: '金额',
    purposeView: '用途（收款方可查看）',
    operation: '操作',
    vitro: '体外支付',
    paymentOperation: '订单操作',
    setPaymentDate: '设置付款日',
    viewAndPay: '查看并支付',
    cancelPay: '取消支付',
    cancelTip: '注意：被取消的支付单将被从页面中移除，需重新上传申请并审批后才能再次支付。',
    cancelConfirmTip: '确认取消？',
    selectTip: '请选择支付单',
    vendorName: '供应商名称',
    vendorComment: '供应商备注',
    paymentDate: '付款日期',
    paymentDateP: '付款日期不能为空',
    purpose: '用途',
    comment: '备注',
    uploadPaymentReceipt: '上传支付回执',
    cancel: '取消',
    confirmPay: '确认支付',
    ReceiptCertificate: '回执凭证',
    PaymentBank: '付款银行',
    PaymentBankNO: '付款银行账号',
    PaymentBankNumber: '付款银行行号',
    PaymentBankName: '付款银行名称',
    ReceivingBank: '收款银行',
    ReceivingBankNO: '收款银行账号',
    ReceivingBankNumber: '收款银行行号',
    ReceivingBankName: '收款银行名称',
    PaymentAmount: '支付金额',
    paymentDay: '付款日',
    paymentDetail: '支付详情',
    cashStatusSimulation: '现金状态模拟',
    Remove: '移除',
    Splitting: '拆分',
    CancelSplitting: '取消拆分',
    AcceptancePayment: '承兑支付',
    HasAcceptancePayment: '已承兑支付',
    CheckAcceptancePayment: '查看承兑票',
    InsertPaymentBuffer: '加入支付序列',
    bankCode: '银行编号',
    bankName: '银行名称',
    bankAccount: '银行账号',
    confirm: '确认',
    selectPaymentBank: '选择付款银行',
    selectReceiveBank: '选择收款银行',
    selectAcceptanceReceiveBank: '选择承兑票收款银行',
    comments: '备注',
    workPaymentDeleteP: '注意：被排除的支付单将回到计划支付单中，如果需要可以再次支付。\r\n确认排除？',
    slipPayment: '拆分支付单',
    toBeSlipPayment: '待拆分支付单',
    slipAmount: '拆分金额',
    slipAmountP: '拆分金额过大，无法拆分',
    slipAmountCannotBeZeroP: '拆分金额需大于0',
    afterSlipPayment: '拆分后支付单',
    preView: '预览',
    cancelSlipPayment: '取消拆分支付单',
    toBeCancelSlipPayment: '待取消拆分支付单',
    afterCancelSlipPayment: '取消拆分后支付单',
    workPaymentSubmitP: '注意：加入支付序列后，系统将根据付款日期自动触发付款。如需取消付款或修改付款日，可在待执行支付单内操作。\n确认加入？',
    paymentHistory: '历史支付单',
    paymentSlipType: '支付方式',
    status: '状态',
    DownloadCertificate: '凭证下载',
    viewDetails: '查看详情',
    all: '全部',
    hasPayment: '已支付',
    Cancelled: '已取消',
    BatchDownloadCertificate: '批量下载凭证',
    orderFunction: '订单功能',
    draftNo: '票据号',
    draftType: '票据种类',
    splitFlag: '可拆包标记',
    issueDate: '出票日期',
    draftBankName: '承兑人银行',
    banendFlag: '不得转让标记',
    draftAmt: '票据金额',
    payingBank: '付款银行',
    acceptanceList: '承兑票一览',
    usedAmount: '使用金额',
    paymentStatement: '交易流水',
    LoanMarking: '借贷标记',
    date: '日期',
    lend: '借',
    loan: '贷',
    transactionType: '交易类型',
    transferInto: '转入',
    transferOut: '转出',
    otherPartyName: '对方账户名称',
    statementUniqueIdentifier: '流水唯一标识号',
    accountingDate: '记账日期',
    transactionAmount: '交易金额',
    balance: '余额',
    businessType: '业务类型',
    abstractAbbreviation: '摘要简称',
    abstractDescription: '摘要描述',
    coreNote: '核心备注',
    downloadHistoryReceipt: '下载历史回单',
    paymentSlip: '支付单',
    acceptanceUse: '承兑票使用',
    useAmount: '使用金额',
    useAmountError: '使用金额错误',
    executePayment: '待执行支付单',
    updatePaymentDate: '变更付款日',
    currentAccountBalance: '当前账户余额',
    currentAvailableBalance: '当前可用余额',
    paymentAmount: '支付金额',
    payDate: '支付日期',
    uploadDropFile: '将文件拖拽到此处，',
    uploadDropOr: '或',
    uploadDropClick: '点击上传',
    confirmVitro: '确认体外支付',
    batchOutsideConfirm: '批量体外支付确认',
    batchOutsideConfirmSuccess: '批量体外支付确认成功',
    selectForeignCurrencyTip: '不能选择体外支付单进行查看和支付',
    correlateName: '对方账户名称',
    attachInfo: '流水唯一标识号',
    trnAMT: '交易金额',
    loadMore: '加载更多',
    paymentVoucherIsNull: '支付凭证为空',
    paymentError: '支付失败',
    toBeConfirmed: '待确认',
    bankEmptyAlertMessage: '收款方银行列表为空，或在当前页面未选中收款银行',
    paymentTime: '支付时间',
    historyReceipt: '下载回单',
    slipAmountTip: '* 拆分金额需小于待拆分项支付金额',
    acceptancePayment: '承兑支付',
    acceptancePaymentTip: '* 承兑票使用总金额需等于支付单支付金额',
    vitroPayTip: '注意：请确认已在银行客户端完成支付操作后，保留支付凭证，再由本页更新支付状态。',
    acceptancePaymentConfirmTip: '* 确认后将立即支付',
    currentReceivingBank: '当前收款银行',
    showTotalAmount: '查看汇总金额',
    totalAmountPayable: '待支付总金额',
    plannedTotalAmountPayable: '计划支付单总金额',
    reportDisplayTypes: '报表显示形式',
    supplierSumDisplay: '按供应商汇总',
    singleRowDisplay: '单行信息',
    supplierSumAndSingleRowDisplay: '供应商汇总加单行信息',
    foreignExchangeOrExternal: '外汇 (或体外支付)'
  },
  fileUpload: {
    uploadText: '将文件拖到此处，或',
    clickUpload: '点击上传',
    excelFileUploadTip: '只能上传xlsx/xls文件',
    upload: '上传',
    uploadSuccess: '上传成功!',
    uploadError: '上传失败!'
  },
  Acceptance: {
    id: '序号',
    requestObject: '请求方',
    requestObjectName: '请求方名称',
    requestObjectBankName: '请求方开户行名称',
    requestTime: '请求时间',
    draftNo: '票据号',
    draftRange: '子票区间',
    orderFunction: '订单功能',
    viewDetails: '查看详情',
    requestDate: '请求日期',
    draftType: '票据种类',
    bankName: '承兑人银行',
    draftAmt: '票据金额',
    status: '状态',
    approvalProcess: '发起签收审批',
    rejectApproval: '发起拒绝审批',
    batchAcceptance: '批量签收',
    batchAcceptanceP: '批量签收',
    selectSignatureTip: '请选择需要签收的承兑票',
    batchReject: '批量拒绝',
    selectRefuseTip: '请选择需要拒绝的承兑票',
    initiateApproval: '发起审批',
    totalAmount: '票据金额合计',
    approvalType: '审批类型',
    approvalTypeP: '审批类型不能为空',
    acceptanceReceipt: '承兑票接收',
    acceptanceReceiptDetail: '承兑票详情',
    acceptedBillsPendingApproval: '待审批承兑票',
    receiveBankName: '接收银行名称',
    banendFlag: '请求不得转让标记',
    splitFlag: '可拆包标记',
    requestEntrustPay: '请求到期无条件委托标记',
    issueDate: '出票日期',
    dueDate: '到期日',
    dueDateTime: '到期日期',
    Refuse: '拒绝',
    Signature: '签收',
    approveAcceptance: '承兑票审批',
    currentApprover: '当前审批人',
    submitDate: '提交日期',
    Submitter: '提交人',
    all: '全部',
    submitTime: '提交时间',
    finalApprover: '最终审批人',
    operationTime: '操作时间',
    historicalAcceptance: '历史承兑票',
    approvalHistory: '审批历史',
    requestBankName: '请求方开户行名称',
    responseObject: '应答方名称',
    responseBankName: '应答方开户行名称',
    banendFlagTrue: '不得转让标记',
    signupMark: '应答标识',
    approveAcceptanceHistory: '承兑票审批历史',
    approveDetail: '审批详情',
    AcceptanceTotalAmount: '票据金额合计',
    rejectionReason: '驳回原因',
    behaveNo: '行为序号',
    behaveType: '行为种类',
    behaveDate: '行为日期',
    usedAmount: '使用金额',
    dateScopeRange: '出票日期范围',
    dueDateScopeRange: '到期日期范围',
    signForReceipt: '申请签收',
    applicationRejected: '申请拒绝',
    confirmedDismissal: '确认驳回',
    rejectionReasonTip: '注意:被驳回的承兑票将回退到待接收列表，可重新申请审批。',
    selectApprovalTip: '请选择需要审批的承兑票',
    transactionHistory: '流转记录',
    acceptanceBank: '接受银行'
  },
  acceptanceStatus: {
    pendingConfirmation: '待确认',
    underReview: '审批中',
    pendingAction: '待操作',
    operated: '已操作',
    received: '已签收',
    rejected: '已拒绝'
  },
  paymentSlipTypes: {
    cash: '现汇支付',
    vitro: '体外支付',
    acceptance: '承兑支付'
  }
}
